import React from "react";

const BoardSkeletonList = ({ imageFormatEnabled }) => (
  <>
    {Array.from({ length: 4 }).map((_, index) => (
      <article
        className={`feature-card board-card board-skeleton ${imageFormatEnabled ? "has-media" : "no-media"}`}
        aria-hidden="true"
        key={`board-skeleton-${index}`}
      >
        <div className={`board-card-main ${imageFormatEnabled ? "has-media" : "no-media"}`}>
          {imageFormatEnabled ? <span className="board-card-media board-skeleton-media" /> : null}
          <span className="board-card-copy">
            <span className="skeleton-line skeleton-title" />
            <span className="skeleton-line skeleton-action" />
          </span>
        </div>
      </article>
    ))}
  </>
);

export default BoardSkeletonList;
